export class MinRetentionRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "minimumRetention",
            "baseName": "minimumRetention",
            "type": "number",
            "format": ""
        },
        {
            "name": "frequency",
            "baseName": "frequency",
            "type": "MinRetentionRuleFrequencyEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MinRetentionRule.attributeTypeMap;
    }
    constructor() {
    }
}
export var MinRetentionRuleFrequencyEnum;
(function (MinRetentionRuleFrequencyEnum) {
    MinRetentionRuleFrequencyEnum["Daily"] = "DAILY";
    MinRetentionRuleFrequencyEnum["Weekly"] = "WEEKLY";
    MinRetentionRuleFrequencyEnum["Monthly"] = "MONTHLY";
    MinRetentionRuleFrequencyEnum["Annual"] = "ANNUAL";
})(MinRetentionRuleFrequencyEnum || (MinRetentionRuleFrequencyEnum = {}));
